<template>
    <div>
        <b-alert show>REFUNDS</b-alert>
        /sales/refund_process/

        <div style="width: 98%; margin: auto;">

            <div style="display: block; margin-bottom: 10px;">
                <b-form @submit="search_invoice_for_refund" autocomplete="off">
                    <div style="display: inline-block; vertical-align: top;">
                        <b-input style="width: 300px;" v-model="search_query"></b-input>
                    </div>
                    <div style="display: inline-block; vertical-align: top;">
                        <b-button variant="primary" type="submit" @click="search_invoice_for_refund" :disabled="invoice_being_searched">SEARCH</b-button>
                    </div>
                </b-form>
            </div>

            <b-card no-body>

                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="'invoices'" variant="info">INVOICES</b-button>
                </b-card-header>


                 <b-collapse id="invoices" visible accordion="my-accordion" role="tabpanel">

                    

                    <div style="height: auto; max-height: 300px; overflow-y: scroll; display: block;">
                        <div v-if="invoice_being_searched">
                            <loading :active="true" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                        </div>

                        <div v-else-if="invoice_being_searched == false">
                            <div v-if="search_results.length > 0">
                                <table style="width: 100%;">
                                    <thead>
                                        <tr style="background: black; color: white; font-weight: bold; font-size: 14px; text-align: center;">
                                            <td style="border: 1px solid black;">SOLD ON</td>
                                            <td style="border: 1px solid black;">INVOICE #</td>
                                            <td style="border: 1px solid black;">CUSTOMER NAME</td>
                                            <td style="border: 1px solid black;">CUSTOMER PHONE</td>
                                            <td style="border: 1px solid black;">EMAIL</td>
                                            <td style="border: 1px solid black;"># ITEMS</td>

                                            <td style="border: 1px solid black;">ACTION</td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr style="background: white; color: black; font-weight: bold; font-size: 14px; text-align: center;" v-for="inv, invidx in search_results" v-bind:key="invidx">
                                            <td style="border: 1px solid black;">{{inv.ts}}</td>
                                            <td style="border: 1px solid black;">{{inv.invoice_id}}</td>
                                            <td style="border: 1px solid black;">{{inv.customer_name}}</td>
                                            <td style="border: 1px solid black;">{{inv.customer_phone}}</td>
                                            <td style="border: 1px solid black;">{{inv.customer_email}}</td>
                                            <td style="border: 1px solid black;">{{inv.n_items}}</td>

                                            <td style="border: 1px solid black;"><b-button size="sm" variant="secondary" @click="get_items_for_invoice(inv.invoice_id)">SELECT</b-button></td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                            <div v-else>
                                <b-alert show variant="warning">NO INVOICES. PLEASE SEARCH AN INVOICE TO BEGIN.</b-alert>
                            </div>
                        </div>

                        <div v-else>
                        </div>
                    </div>
                </b-collapse>
            </b-card>


            <b-card no-body v-if="items_being_loaded != null">

                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="'invoice_items'" variant="info" style="font-weight: bold;">INVOICE # {{picked_invoice_id}}</b-button>
                </b-card-header>

                <b-collapse id="invoice_items" :visible="invoice_items.length > 0" accordion="my-accordion" role="tabpanel">
                    <div>
                        <div v-if="items_being_loaded">
                            <loading 
                                :active="true" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                        </div>

                        <div v-else-if="items_being_loaded == false">
                            <div v-if="invoice_items.length > 0">

                                <table style="width: 100%;">
                                    <thead>
                                        <tr style="background: #efefef; color: black; font-weight: bold; font-size: 14px; text-align: center;">
                                            <td style="border: 1px solid black; width: 80px;">
                                                RETURN
                                            </td>

                                            <td style="border: 1px solid black; width: 200px;">
                                                PRODUCT NAME
                                            </td>

                                            <td style="border: 1px solid black; width: 200px;">
                                                PRODUCT SKU
                                            </td>

                                            <td style="border: 1px solid black; width: 100px;">
                                                TYPE
                                            </td>

                                            <td style="border: 1px solid black; width: 100px;">
                                                STATE
                                            </td>

                                            <td style="border: 1px solid black; width: 90px;">
                                                UNIT PRICE
                                            </td>

                                            <td style="border: 1px solid black; width: 80px;">
                                                PURCHASED QTY
                                            </td>

                                            <td style="border: 1px solid black; width: 80px;">
                                                REFUNDED QTY
                                            </td>

                                            <td style="border: 1px solid black; width: 80px;">
                                                REMAINING QTY
                                            </td>

                                            <td style="border: 1px solid black; width: 80px;">
                                                RETURN QTY
                                            </td>

                                            <td style="border: 1px solid black; width: 150px;">
                                                RETURN REASON
                                            </td>

                                            <td style="border: 1px solid black; width: 150px;">
                                                RETURN LOCATION
                                            </td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="item,idx in invoice_items" style="background: white; color: black; font-weight: normal; font-size: 14px; text-align: center;" v-bind:key="idx">
                                            <td style="border: 1px solid black;">
                                                <b-form-checkbox v-model="item.is_returned" name="check-button" switch>
                                                </b-form-checkbox>
                                            </td>

                                            <td style="border: 1px solid black;">
                                                {{ item.product_name }}
                                            </td>

                                            <td style="border: 1px solid black;">
                                                {{ item.product_sku }}
                                                {{  ((item.is_special == true) ? ' (SPECIAL)' :  '') }}
                                            </td>

                                            <td style="border: 1px solid black;">
                                                {{ item.order_type }}
                                            </td>

                                            <td style="border: 1px solid black;">
                                                {{ states_dict[item.state] }}
                                            </td>

                                            <td style="border: 1px solid black;">
                                                $ {{ (item.selling_price || 0.0).toFixed(2) }}
                                            </td>

                                            <td style="border: 1px solid black;">
                                                {{ item.quantity }}
                                            </td>

                                            <td style="border: 1px solid black;">
                                                {{ item.total_returned_quantity }}
                                            </td>

                                            <td style="border: 1px solid black;">
                                                {{ item.quantity - item.total_returned_quantity }}
                                            </td>

                                            <td style="border: 1px solid black;">
                                                <b-form-select size="sm" style="font-size: 14px;" v-model="item.return_quantity" :options="get_quantity_dd(item.quantity)"></b-form-select>
                                            </td>

                                            <td style="border: 1px solid black;">
                                                <b-form-select size="sm" style="font-size: 14px;" v-model="item.return_reason" :options="return_reasons"></b-form-select>
                                            </td>

                                            <td style="border: 1px solid black;">
                                                <b-form-select size="sm" style="font-size: 14px;" v-model="item.return_locsub" :options="packet.locations"></b-form-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-else>
                            <b-alert show variant="warning">NO INVOICE ITEMS</b-alert>

                            // calculate the percentage of this refund against total payment made by customer (in payment methods).
                            // same % of sales tax will be returned. (manually editable)
                            // same % of charges will be returned (manually editable)
                        </div>
                    </div>
                </b-collapse>
            </b-card>

            <b-card no-body  v-if="invoice_items.filter(function(d){ return d.is_returned}).length > 0">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="'refund_summary'" variant="info" style="font-weight: bold;">REFUND SUMMARY</b-button>
                </b-card-header>

                <b-collapse id="refund_summary"  accordion="my-accordion" role="tabpanel">
                    <b-alert show variant="secondary">REFUNDED ITEMS</b-alert>
                    <table style="width: 100%;">
                        <thead>
                            <tr style="background: #efefef; color: black; font-weight: bold; font-size: 14px; text-align: center;">
                                <td style="border: 1px solid black; width: 200px;">
                                    PRODUCT NAME
                                </td>

                                <td style="border: 1px solid black; width: 200px;">
                                    PRODUCT SKU
                                </td>

                                <td style="border: 1px solid black; width: 90px;">
                                    UNIT PRICE
                                </td>

                                <td style="border: 1px solid black; width: 80px;">
                                    RETURN QTY
                                </td>

                                <td style="border: 1px solid black; width: 100px;">
                                    RETURN AMOUNT
                                </td>

                                <td style="border: 1px solid black; width: 150px;">
                                    RETURN REASON
                                </td>

                                <td style="border: 1px solid black; width: 150px;">
                                    RETURN LOCATION
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item,idx in get_returned()" style="background: white; color: black; font-weight: normal; font-size: 14px; text-align: center;" v-bind:key="idx">

                                <td style="border: 1px solid black;">
                                    {{ item.product_name }}
                                </td>

                                <td style="border: 1px solid black;">
                                    {{ item.product_sku }}
                                    {{  ((item.is_special == true) ? ' (SPECIAL)' :  '') }}
                                </td>

                                <td style="border: 1px solid black;">
                                    $ {{ (item.selling_price).toFixed(2) }}
                                </td>

                                <td style="border: 1px solid black;">
                                    {{ (item.return_quantity || 0) }}
                                </td>

                                <td style="border: 1px solid black;">
                                    $ {{ (item.return_quantity * item.selling_price).toFixed(2) }}
                                </td>

                                <td style="border: 1px solid black;">
                                    <b-form-select size="sm" style="font-size: 14px;" :disabled="true" v-model="item.return_reason" :options="return_reasons"></b-form-select>
                                </td>

                                <td style="border: 1px solid black;">
                                    <b-form-select size="sm" style="font-size: 14px;" :disabled="true" v-model="item.return_locsub" :options="packet.locations"></b-form-select>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%;">
                        <tr>
                            <b-alert size="sm" show>REFUND AMOUNTS</b-alert >
                            <td style="border: 1px dotted;">
                                    <table style="width: 30%; font-size: 14px;">
                                        <tr>
                                            <td style="border: 1px solid; padding: 3px;">CURRENT PRODUCT REFUND</td>
                                            <td style="border: 1px solid; padding: 3px;">$ {{  
                                                (
                                                    get_refund_items_total()
                                                ).toFixed(2)
                                            }}</td>
                                        </tr>

                                        <tr>
                                            <td style="border: 1px solid; padding: 3px;">REFUND SETUP FEES</td>
                                            <td style="border: 1px solid; padding: 3px;">$ <b-input 
                                                :disabled="get_total_setup() == 0" 
                                                size="sm" 
                                                v-model="refund.total_setup_refund" 
                                                style="width: 60px; display: inline-block;"></b-input> / {{ 
                                                    (
                                                        get_total_setup() - get_total_refunded_setup_sofar()
                                                    ).toFixed(2)     
                                            }}</td>
                                        </tr>

                                        <tr>
                                            <td style="border: 1px solid; padding: 3px;">REFUND DELIVERY FEES</td>
                                            <td style="border: 1px solid; padding: 3px;">$ <b-input 
                                                :disabled="get_total_delivery() == 0" 
                                                size="sm" 
                                                v-model="refund.total_delivery_refund" 
                                                style="width: 60px; display: inline-block;"></b-input> / {{ 
                                                    (
                                                        get_total_delivery() -  get_total_refunded_delivery_sofar()
                                                    ).toFixed(2)    
                                            }}</td>
                                        </tr>

                                        <tr>
                                            <td style="border: 1px solid; padding: 3px;">REFUND WARRANTY CHARGES</td>
                                            <td style="border: 1px solid; padding: 3px;">$ <b-input  
                                                size="sm" 
                                                v-model="refund.total_warranty_refund" 
                                                :disabled="get_total_warranty() == 0" 
                                                style="width: 60px; display: inline-block;"></b-input> / {{ 
                                                    (
                                                        get_total_warranty() - get_total_refunded_warranty_sofar()
                                                    ).toFixed(2) 
                                            }}</td>
                                        </tr>

                                        <tr>
                                            <td style="border: 1px solid; padding: 3px;">TAX TOTAL REFUND</td>
                                            <td style="border: 1px solid; padding: 3px;">$ {{ 
                                                (
                                                    ( get_total_sales_tax() - get_total_refunded_sales_tax() ) * get_total_tax_refund_perc()
                                                ).toFixed(2) 
                                            }}</td>
                                        </tr>

                                        <tr>
                                            <td style="border: 1px solid; padding: 3px; font-weight: bold; background: black; color: white;">TOTAL REFUND VALUE</td>
                                            <td style="border: 1px solid; padding: 3px; font-weight: bold;">$ {{  
                                                (
                                                    get_total_refund_value()
                                                ).toFixed(2)
                                            }}</td>
                                        </tr>
                                    </table>
                            </td>
                            <td style="border: 1px dotted;">
                                <table style="width: 30%; font-size: 14px;">
                                    

                                </table>

                            </td>
                            <td style="border: 1px dotted;">C</td>
                        </tr>
                    </table>
                </b-collapse>
            </b-card>
        </div>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css' // Optional CSS

    import mappings from '@/utilities/mappings'

    export default {
        name: "RefundProcess",
        components: {Loading, Requestor},
        data: function(){
            return {
                packet: {},
                states_dict: mappings.states_dict,

                items_being_loaded: null,
                invoice_items: [],
                selected_items: [],

                invoice_being_searched: null,
                search_query: null,
                search_results: [],

                return_locations: [],
                return_reasons: [
                    {value: 0, text: "OTHER"},
                    {value: 1, text: "ITEM DAMAGED"},
                    {value: 2, text: "ITEM INCOMPLETE"},
                ],
                refund: this.get_refund_packet(),
            }
        },
        methods: {
            get_total_refund_value:  function(){
                let items = [
                    this.get_refund_items_total(),
                    (this.refund.total_setup_refund || 0.0),
                    (this.refund.total_delivery_refund || 0.0),
                    (this.refund.total_warranty_refund || 0.0),
                    (( this.get_total_sales_tax() - this.get_total_refunded_sales_tax() ) * this.get_total_tax_refund_perc())
                ];
                let s = this.sum(items) * 1.0;
                return s;
            },

            get_total_tax_refund_perc: function(){
                //.10
                let refund_items_total = (this.get_refund_items_total() || 0.0); 
                let refund_setup_total = (this.refund.total_setup_refund || 0.0);
                let refund_delivery_total = (this.refund.total_delivery_refund || 0.0);
                let refund_warranty_total = (this.refund.total_warranty_refund || 0.0);

                let n = refund_items_total +  refund_setup_total + refund_delivery_total + refund_warranty_total;

                let items_total = (this.get_items_total() || 0.0);
                let setup_total = (this.get_total_setup() || 0.0);
                let delivery_total = (this.get_total_delivery() || 0.0);
                let warranty_total = (this.get_total_warranty() || 0.0);

                let d = items_total + setup_total + delivery_total + warranty_total;
                return  (n * 1.0) / d;

            },
            get_items_total: function(){
                let out =  0.0;
                let items = this.invoice_items;
                if (items.length > 0){
                    out = this.sum(items.map(function(d){return d.selling_price * d.quantity}));
                }
                return out;
            },
            get_total_setup: function(){
                let v = 0;
                let items = this.invoice_items;
                if ( (items || []).length > 0){
                    v = items[0].setup_charges;
                }
                return v
            },
            get_total_refunded_setup_sofar: function() {
                let v = 0;
                let items = this.invoice_items;
                if ( (items || []).length > 0){
                    v = items[0].total_refunded_setup;
                }
                return v
            },
            get_total_delivery: function(){
                let v = 0;
                let items = this.invoice_items;
                if ( (items || []).length > 0){
                    v = items[0].delivery_charges;
                }
                return v
            },
            get_total_refunded_delivery_sofar: function() {
                let v = 0;
                let items = this.invoice_items;
                if ( (items || []).length > 0){
                    v = items[0].total_refunded_delivery;
                }
                return v
            },
            get_total_warranty: function(){
                let v = 0;
                let items = this.invoice_items;
                if ( (items || []).length > 0){
                    v = items[0].warranty_charges;
                }
                return v
            },
            get_total_refunded_warranty_sofar: function(){
                let v = 0;
                let items = this.invoice_items;
                if ( (items || []).length > 0){
                    v = items[0].total_refunded_warranty;
                }
                return v
            },
            get_total_sales_tax: function(){
                let v = 0;
                let items = this.invoice_items;
                if ( (items || []).length > 0){
                    v = items[0].sales_tax;
                }
                return v
            },
            get_total_refunded_sales_tax: function(){
                let v = 0;
                let items = this.invoice_items;
                if ( (items || []).length > 0){
                    v = items[0].total_refunded_sales_tax;
                }
                return v
            },
            get_refund_items_total: function(){
                let returned_items = this.get_returned();
                let out = this.sum(returned_items.map(function(d){return d.return_quantity * d.selling_price}));
                return out;
            },
            get_returned: function(){
                return this.invoice_items.filter(function(d){ return d.is_returned == true && d.return_quantity > 0});
            },
            sum: function(items){
                return items.reduce((pv, cv) => pv + cv, 0.0) * 1.0;
            },
            get_quantity_dd: function(quantity){
                return [...Array(quantity+1).keys()].map(function(d){return {value: d, text: d}})
            },
            search_invoice_for_refund: function(){
                let path = "/api/refund/search_invoice_for_refund/"
                let data = {search_query: this.search_query};
                let that = this;

                let s = function(response){
                    if (response.data.result){
                        console.log(response.data.result)
                        that.search_results = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.invoice_being_searched = false;
                    
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error looking up invoices. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.invoice_being_searched = false;
                }
                this.search_results = [];
                this.invoice_being_searched = true
                this.invoice_items = [];
                this.refund = this.get_refund_packet();
                Requestor.getSync(path, data, s, f);
            },
            get_items_for_invoice: function(invoice_id){
                this.picked_invoice_id = invoice_id;
                let path = "/api/refund/get_items_for_refund/"
                let data = {invoice_id: invoice_id};
                let that = this;

                let s = function(response){
                    if (response.data.result){
                        console.log(response.data.result)
                        that.invoice_items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                    
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error looking up invoices. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true
                this.invoice_items = [];
                this.refund = this.get_refund_packet();
                Requestor.postSyncP(path, data, this, s, f);
            },
            get_refund_packet: function(){
                return {
                    total_tax_returned: 0.0,
                    total_setup_refund: 0.0,
                    total_delivery_refund: 0.0,
                    total_warranty_refund: 0.0,
                    invoice_id: null,
                    items: [],
                    refund_methods: []
                }
            }



        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Sales/RefundProcess.vue